// Regras de validade da URL assinada de um anexo.
//
// A assinatura precisa durar mais que o tempo em que a URL fica guardada em
// cache. Os dois valiam 1 hora: uma URL entregue no fim da janela de cache
// chegava ao <video> já expirando, e o vídeo parava no meio da reprodução —
// tocar não é um download único, o player continua pedindo faixas do arquivo
// enquanto avança, e cada pedido novo vai com a mesma URL.
//
// Com a assinatura valendo o dobro da janela de cache, a URL entregue tem
// sempre pelo menos CACHE_DURATION_MS de vida pela frente.

export const SIGNED_URL_TTL_SECONDS = 2 * 60 * 60;
export const CACHE_DURATION_MS = 60 * 60 * 1000;

// Margem garantida de vida restante na URL mais velha que o cache entrega.
export const MARGEM_MINIMA_MS = SIGNED_URL_TTL_SECONDS * 1000 - CACHE_DURATION_MS;

export function cacheAindaValido(gravadoEm: number, agora: number): boolean {
  return agora - gravadoEm < CACHE_DURATION_MS;
}
